import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  NgZone
} from "@angular/core";
import { MapsAPILoader, MouseEvent } from "@agm/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { environment } from ".././../../../environments/environment";
declare var google;
@Component({
  selector: "app-pickup-location",
  templateUrl: "./pickup-location.component.html",
  styleUrls: ["./pickup-location.component.scss"]
})
export class PickupLocationComponent implements OnInit {
  latitude: number;
  longitude: number;
  zoom: number;
  pickup_location: string;
  pickupForm: FormGroup;
  pickupCleared: Boolean;
  pickupSelected: Boolean;
  url: any;
  private geoCoder;
  @ViewChild("pickup_field", { static: false })
  public searchElementRef: ElementRef;
  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.pickupForm = this.fb.group({
      pickup_field: ["", Validators.compose([Validators.required])]
    });
    this.pickupCleared = true;
    this.pickupSelected = true;
  }

  ngOnInit() {
    this.url = environment.apiUrl;
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder();
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          // get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          // set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 15;
          this.setAddress(this.latitude, this.longitude);
        });
      });
    });
    if (localStorage.pickup_location) {
      this.pickup_location = localStorage.pickup_location;
      this.pickupCleared = true;
    }
  }

  private setCurrentLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 15;
        if (localStorage.pickup_lon && localStorage.pickup_lat) {
          this.latitude = parseFloat(localStorage.pickup_lat);
          this.longitude = parseFloat(localStorage.pickup_lon);
        }
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  markerDragEnd($event: MouseEvent) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.setAddress(this.latitude, this.longitude);
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.zoom = 15;
            this.pickupSelected = false;
            if (!localStorage.pickup_location) {
              this.pickup_location = results[0].formatted_address;
              this.pickupCleared = true;
            }
          } else {
            console.log("No results found");
          }
        } else {
          console.log("Geocoder failed due to: " + status);
        }
      }
    );
  }

  setAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === "OK") {
          this.pickupSelected = false;
          if (results[0]) {
            this.zoom = 15;
            this.pickup_location = results[0].formatted_address;
            this.pickupCleared = true;
          } else {
            console.log("No results found");
          }
        } else {
          console.log("Geocoder failed due to: " + status);
        }
      }
    );
  }

  confirmLocation(formdata) {
    if (this.pickupForm.valid) {
      localStorage.setItem("pickup_lat", this.latitude.toString());
      localStorage.setItem("pickup_lon", this.longitude.toString());
      localStorage.setItem("pickup_location", this.pickup_location);
      this.router.navigate(["/search"]);
    } else {
      this.validateAllFormFields(this.pickupForm);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  clearPickup() {
    if (this.pickup_location && this.pickupCleared) {
      this.pickup_location = null;
      this.pickupCleared = false;
      this.pickupSelected = true;
    }
  }

  fetchMyLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 15;
        this.setAddress(this.latitude, this.longitude);
      });
    }
  }
}
